export const MINIMAL_SYMBOL_COUNT = 3;
export const CACHED_VALUE = '';
export const ACCEPTED_KEYS = ['ArrowUp', 'ArrowDown', 'Escape', 'Enter'];
export const INITIAL_FIELD_STATE = {
    description: '',
    coordinates: {
        lat: null,
        lng: null,
    },
};
export const DEBOUNCE_DEFAULT_VALUE = 150;
export const CACHE_DEFAULT_VALUE = 86400; // 24 * 60 * 60
